import { breakPoints } from '../constants';

import { useMediaQuery } from './useMediaQuery';

export function useLayout() {
    const isTablet = useMediaQuery({ maxWidth: breakPoints.MD });
    const isMobile = useMediaQuery({ maxWidth: breakPoints.XS });

    return {
        isMobile,
        isTablet,
        isDesktop: !isMobile && !isTablet,
    };
}
